$(document).ready(() => {

    $('.js-filter-team').click(function(e){
        e.preventDefault();
        $(this).addClass('active').siblings('.js-filter-team').removeClass('active');
        $('.js-start-team-filter').click();
    });

    $('.js-start-team-filter').click(function(e){
        e.preventDefault();
        filterTeam($(this), 'filter');
    });

    $('.js-clear-team-filter').click(function(e){
        e.preventDefault();
        let $this = $(this);
        $this.parents('.team').find('.box-category').removeClass('active');
        $this.parents('.team').find('.box-category[data-type="all"]').addClass('active');
        $this.parents('.team').find('select').val('').trigger('change');
        //$this.parents('.team').find('form').get(0).reset();
        setTimeout(function(){
            filterTeam($this, 'filter');
        }, 100);
    });

    $(document).on('click', '.js-paged-team a.page-numbers', function(e){
        e.preventDefault();
        $(this).addClass('current').siblings('.page-numbers').removeClass('current');
        filterTeam($(this), 'load');
    });

    function filterTeam($el, $event){
        let $parent = $el.parents('.team');
        let $numberposts = $parent.data('numberposts');
        let $categories = $parent.data('categories');
        let $search = $parent.find('.box-category.active').data('type');
        let $position = $parent.find('[name="position"]').val();
        let $institute = $parent.find('[name="institute"]').val();
        let $paged = 1;
        if ($event == 'load' && $parent.find('.page-numbers.current').length) {
            $paged = $parent.find('.page-numbers.current').text();
        }
        let teamWrapp = $el.parents('.team .container');

        $('.loader').show();
        $.ajax({
            url: myajax.url,
            dataType: 'json',
            method: 'POST',
            data: {
                action: 'filter_team',
                numberposts: $numberposts,
                search: $search,
                position: $position,
                institute: $institute,
                categories: $categories,
                paged: $paged,
            },
            success(data) {
                teamWrapp.find('.block-team, .pagination').remove();
                teamWrapp.append(data.content);

                if ($event == 'load') {
                    $("html, body").animate({ scrollTop: 0 }, 600);
                }
            },
            complete: function(){
                $('.loader').hide();
            },
        });
    }

});
